import { REQUEST, FAILURE, SUCCESS, action, createRequestTypes } from 'redux-config/reduxHelpers';
import { createFormAction } from 'redux-form-saga';

export const GET_USER_CHALLENGES = createRequestTypes('GET_USER_CHALLENGES');
export const getUserChallenges = {
  request: search => action(GET_USER_CHALLENGES[REQUEST], search),
  success: data => action(GET_USER_CHALLENGES[SUCCESS], { data }),
  failure: error => action(GET_USER_CHALLENGES[FAILURE], { error }),
};

export const GET_CHALLENGES = createRequestTypes('GET_CHALLENGES');
export const getChallenges = {
  request: () => action(GET_CHALLENGES[REQUEST]),
  success: data => action(GET_CHALLENGES[SUCCESS], { data }),
  failure: error => action(GET_CHALLENGES[FAILURE], { error }),
};

export const activateChallenge = createFormAction('ACTIVATE_CHALLENGE');

export const changeRefundableFeeRecieveMethod = createFormAction('CHANGE_REFUNDABLE_METHOD');

export const GET_CHALLENGE = createRequestTypes('GET_CHALLENGE');
export const getChallenge = {
  request: id => action(GET_CHALLENGE[REQUEST], { id }),
  success: data => action(GET_CHALLENGE[SUCCESS], { data }),
  failure: error => action(GET_CHALLENGE[FAILURE], { error }),
};

export const restartChallenge = createFormAction('RESTART_CHALLENGE');

export const ARCHIVE_CHALLENGE = createRequestTypes('ARCHIVE_CHALLENGE');
export const archiveChallenge = {
  request: (id, onSuccess) => action(ARCHIVE_CHALLENGE[REQUEST], { id, onSuccess }),
  success: data => action(ARCHIVE_CHALLENGE[SUCCESS], { data }),
  failure: error => action(ARCHIVE_CHALLENGE[FAILURE], { error }),
};

export const GET_CHALLENGES_LEADERBOARD = createRequestTypes('GET_CHALLENGES_LEADERBOARD');
export const getChallegesLeaderboard = {
  request: data => action(GET_CHALLENGES_LEADERBOARD[REQUEST], data),
  success: data => action(GET_CHALLENGES_LEADERBOARD[SUCCESS], { data }),
  failure: error => action(GET_CHALLENGES_LEADERBOARD[FAILURE], { error }),
};

export const manualWithdrawProfitFromChallenge = createFormAction('MANUAL_WITHDRAW_PROFIT_FROM_CHALLENGE');

export const MANUAL_WITHDRAW_ERROR = 'MANUAL_WITHDRAW_ERROR';

export const manualWithdrawActionError = error => action(MANUAL_WITHDRAW_ERROR, { error });

export const MANUAL_WITHDRAW_ERROR_CLEAR = 'MANUAL_WITHDRAW_ERROR_CLEAR';

export const manualWithdrawActionErrorClear = () => action(MANUAL_WITHDRAW_ERROR_CLEAR);
